import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { TransactionDateFilterKeyList } from '@/models/transaction/transaction-list-filter.model';
import {
  TransactionListItem,
  TransactionListResponseModel,
  TransactionListRequestModel,
} from '@/models/transaction/transaction-list.model';
import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';

export default class GetTransactionListRequest extends ApiResourceMethod<TransactionListResponseModel> {
  public perform(wlSlug: string, params: TransactionListRequestModel) {
    const requestData = { ...params };

    if (requestData.filterList && Object.keys(requestData.filterList).length > 0) {
      requestData.filterList = formatDatesInPayload({
        payload: { ...requestData.filterList },
        isUnixToString: false,
        isIncludeTime: true,
      }, [
        TransactionDateFilterKeyList.CREATED_AT_FROM,
        TransactionDateFilterKeyList.CREATED_AT_TO,
        TransactionDateFilterKeyList.UPDATED_AT_FROM,
        TransactionDateFilterKeyList.UPDATED_AT_TO,
      ]);
    }

    return this.performer.requestWithMapper(
      {
        params: clearObj(requestData),
        url: `${wlSlug}/payment`,
      },
      (payload: BaseResponse<TransactionListItem[]>) => {
        return { data: payload.data, headers: payload.headers };
      },
    );
  }
}
